module.exports = __webpack_public_path__ + "img/guoqi.3558ba6b.png";